import React, { useContext } from 'react';
import { IndexContext } from '../../context'

const Banners = ({ banner, styles = {} }) => {
  const { isLogged } = useContext(IndexContext);

  return (
    <section className="index-management container-block">
      <h2 className={`index-management-heading ${styles.managementHeading}`}>
        Scheduling & Aircraft Management System Features
      </h2>
      <div
        className="index-management-slider js--index-management-slider"
        data-flickity='{ "draggable": true, "contain": true, "lazyLoad": true }'
      >
        {banner.map((el, index) => (
            <div className="index-management-slider-item" key={index}>
              <figure className="index-management-slider-item-figure">
                <img
                  srcSet={el.bannerImg}
                  className="index-management-slider-item-img lazyload"
                  alt={el.name}
                  title={el.name}
                />
                <figcaption className="index-management-slider-item-description">
                  <h3 className="index-management-slider-item-h3">{el.name}</h3>
                  <div className="index-management-slider-item-text">{el.content}</div>
                </figcaption>
              </figure>
            </div>
          ))}
      </div>
      {!isLogged && (
        <a
          className="btn-blue index-management-try-demo"
          href="/authorization/registration/"
          children={"Try demo for free!"}
        />
      )}
    </section>
  );
};

export default Banners;
